import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { CareerFormSectionDTO } from '@lib/strapi/dtos/components/sections/careerFormSection.dto';
import CareerForm from '@components/career-form';
import useTranslation from 'next-translate/useTranslation';

const CareerFormSectionImplementation = ({ section }: ComponentProps<CareerFormSectionDTO>) => {
  const { t } = useTranslation('main');
  return (
    // centred card, same frame as the boxed booking form — the old version
    // stretched to the text column's left edge and read as misaligned
    <section className="my-10 mx-auto w-full max-w-xl">
      <CareerForm appointmentHeading={section?.heading ?? t('careers.defaultHeading')} />
    </section>
  );
};

export default CareerFormSectionImplementation;
